<template>
    <ul class="menu" :class="ul_class">     
        <li v-if="is_logged && user && user.tipo == 'user'" class="align">
            <router-link
                :to="{ name: 'perfil' }"
                @click="closeMenu"
                class="gradient-color"
                :class="btn_class"
            >{{ $t('header.perfil') }}</router-link>
        </li>
        <li v-if="is_logged && user && user.tipo != 'user'" class="align">
            <router-link
                :to="{ name: 'back.abonos.index' }"
                @click="closeMenu"
                :class="btn_class"
            >
                {{ $t('header.administracion') }}
            </router-link>
        </li>
        <li class="align" v-if="!is_logged">
            <router-link
                :to="{ name: 'login' }"
                @click="closeMenu"
                :class="btn_class"
            >
                {{ $t('header.login') }}
            </router-link>
        </li>
        <li class="align" v-else>
            <a
                href="#"
                @click="logout"
                :class="btn_class"
            >
                {{ $t('header.cerrar_sesion') }}
            </a>
        </li>
        <li v-if="teatro.carrito_varios_eventos">
            <CarritoOnline v-if="isDesktop" button_color="dark"/>
        </li>
    </ul>
</template>

<script>

    import { config } from '@/config.js';
    import CarritoOnline from '../carrito/CarritoOnline.vue';

    export default {
        props: {
            btn_class: String,
            footer: Object,
            configuracion: Object,
            ul_class: String
        },
        data() {
            return {
                isDesktop : false
            }
        },
        created(){
            this.checkIfDesktop()
        },  
        methods: {
            logout() {
                this.$store.dispatch('logout', { router : this.$router });
            },
            closeMenu() {
                this.$emit('closeMenu');
            },
            checkIfDesktop() {
                this.isDesktop = window.innerWidth > 1024;
            }
        },
        computed: {
            is_logged() {
                return this.$store.getters.isLogged;
            },
            user() {
                return this.$store.getters.getUser;
            },
            abonado(){
                return this.$store.getters.getListaAbonados;
            },
            teatro(){
                return this.$store.getters.getTeatro
            }
        },
        components:{
            CarritoOnline
        }
    }
</script>

<style scoped>
    .align {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        float: center;
    }
</style>